import { DocsButton } from '@/components/DocsButton';
import { Badge, Button, Text } from '@/design-system';
import { IconComponent } from '@/design-system/components/IconButton/IconButton';

export const ProjectNewActionPopoverTrigger = ({
  title,
  badge,
  description,
  docsLink,
  icon: Icon,
  onClick,
}: {
  title: string;
  badge?: string;
  description: string;
  docsLink?: string;
  icon: IconComponent;
  onClick?: () => void;
}) => {
  return (
    <Button
      className="group flex w-full justify-normal gap-2 pb-2"
      onClick={onClick}
      variant="plain"
      color="secondary"
    >
      <Icon className="mr-1 size-5 flex-shrink-0 [&_path]:stroke-[1.2px]" />
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <Text variant="md" weight="medium">
            {title}
          </Text>
          {badge && (
            <Badge color="primary" size="sm" rounded="sm">
              {badge}
            </Badge>
          )}
          {docsLink && (
            <DocsButton
              link={docsLink}
              className="bg-primary hover:!bg-primary group-hover:bg-secondary-hover"
            />
          )}
        </div>
        <Text variant="xs" className="text-quaternary">
          {description}
        </Text>
      </div>
    </Button>
  );
};
